import { useEffect, useState } from 'react';
// Importa la funzione che in realtà sarebbe del contesto ma è spostata in utils per evitare possibili dipendenze cicliche
import { useAppKeycloak } from './keycloakUtils'; 

const TokenRefresher = () => {
  const { keycloak } = useAppKeycloak();
  const [lastActivity, setLastActivity] = useState(Date.now());

  // Funzione per controllare il token e aggiornarlo
  const checkAndRefreshToken = async () => {
    if (!keycloak?.authenticated) return;

    const expiresIn = keycloak.tokenParsed?.exp * 1000 - Date.now();
    if (expiresIn < 60000 && Date.now() - lastActivity < 5 * 60 * 1000) {
      try {
        await keycloak.updateToken(60); // Aggiorna il token se scade entro 60 secondi
      } catch (err) {
        console.error('Errore durante il refresh del token:', err);
      }
    }
  };

  // Listener per aggiornare l'attività dell'utente
  useEffect(() => {
    const updateLastActivity = () => setLastActivity(Date.now());
    window.addEventListener('mousemove', updateLastActivity);
    window.addEventListener('keydown', updateLastActivity);
    window.addEventListener('scroll', updateLastActivity);

    return () => {
      window.removeEventListener('mousemove', updateLastActivity);
      window.removeEventListener('keydown', updateLastActivity);
      window.removeEventListener('scroll', updateLastActivity);
    };
  }, []);

  // Controllo periodico del token
  useEffect(() => {
    const interval = setInterval(checkAndRefreshToken, 30000); // Controlla ogni 30 secondi
    return () => clearInterval(interval); // Pulisce l'intervallo quando il componente viene smontato
  }, [lastActivity, keycloak]);

  return null; // Questo componente non renderizza nulla
};

export default TokenRefresher;